var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxLocationPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#868686;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(86 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.42,21.815a1,1,0,0,0,1.16,0C12.884,21.6,20.029,16.44,20,10A8,8,0,0,0,4,10C3.971,16.44,11.116,21.6,11.42,21.815ZM12,4a6.007,6.007,0,0,1,6,6c.021,4.438-4.388,8.423-6,9.731C10.389,18.427,5.979,14.442,6,10A6.006,6.006,0,0,1,12,4Z",
    transform: "translate(-90 3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLocationPlus);
export default __webpack_public_path__ + "static/media/bx-location-plus.0471e32ac870fd5a9022a1287d8e9154.svg";
export { ForwardRef as ReactComponent };